import { usePage, useWebsiteSettings } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'

import { getWebsiteStylesTypographyHeading } from 'src/publisher/store/website-settings/website-settings-selector'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useCalculateHeadingFontFamily = ({
  fontFamily,
  mobileFontFamily,
}: {
  fontFamily?: string
  mobileFontFamily?: string
}) => {
  const fontProperties = usePage(pageSelectors.getGlobalFontProperties)
  const {
    fontFamily: websiteGlobalFontFamily,
    mobileFontFamily: globalMobileFontFamily,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  const globalFontFamily =
    (fontProperties.headingFontFamily === 'inherit'
      ? undefined
      : fontProperties.headingFontFamily) ||
    (fontProperties.fontFamily === 'inherit'
      ? undefined
      : fontProperties.fontFamily) ||
    websiteGlobalFontFamily

  return {
    calculatedFontFamily: getCalculatedProperty({
      desktopProperty: fontFamily === 'inherit' ? undefined : fontFamily,
      mobileProperty:
        mobileFontFamily === 'inherit' ? undefined : mobileFontFamily,
      globalDesktopProperty: globalFontFamily,
      globalMobileProperty: globalMobileFontFamily,
    }),
    globalFontFamily: globalFontFamily,
    globalMobileFontFamily: globalMobileFontFamily || globalFontFamily,
  }
}
